import styled, { css } from 'styled-components';

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  pointer-events: none;
  * {
    pointer-events: auto;
  }
  grid-template-rows: 77px minmax(0, 1fr) 70px 70px;
  grid-template-columns: minmax(290px, 364px) 1fr minmax(290px, 364px);
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  pointer-events: none;
  * {
    pointer-events: auto;
  }
`;
export const RowOne = styled(Row)`
  grid-column: 1/4;
  max-width: 100vw; // this is to ensure the buttons aren't cut off if the grid is wider than the viewport
`;
export const RowTwo = styled(Row)`
  padding: 0;
  overflow: hidden;
`;
export const BottomRow = styled.div`
  pointer-events: none;
  * {
    pointer-events: auto;
  }
`;
export const HintWrapper = styled.div`
  grid-row: 3 / 6;
  grid-column: 1;
  display: flex;
  padding: 1rem;
  position: relative;
  left: 0;
  ${(props) =>
    !props.$visible &&
    css`
      left: -120%;
    `}
  transition: .5s;
  pointer-events: none;
  * {
    pointer-events: auto;
  }
  align-items: flex-end;
`;
export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  position: relative;
  pointer-events: none;
  grid-row: 2 / 5;
  grid-column: 2;
  ${({ $isMobile, $hasHints }) =>
    $isMobile &&
    !$hasHints &&
    css`
      grid-row: 3 / 5;
      grid-column: 1 / 4;
    `}
  flex-direction: column;
  align-self: flex-end;
  gap: 0.5rem;
  width: 100%;
  max-width: 50rem;
  margin: 0 auto;
  * {
    pointer-events: auto;
  }
`;
export const ObjectivesArea = styled.div`
  pointer-events: none;
  * {
    pointer-events: auto;
  }
`;
export const OverlayToggleWrapper = styled.div`
  z-index: 4;
  padding-top: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CornerWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  pointer-events: none;
  * {
    pointer-events: auto;
  }
`;

export const FullScreenButtonWrapper = styled.div`
  padding: 0.45rem 0;
  position: relative;
`;

export const SubWrapper = styled.div`
  pointer-events: none;
  * {
    pointer-events: auto;
  }
`;

export const ObjectiveGroupsWrapper = styled.div`
  padding: 1rem;
  overflow-y: auto;
  height: 100%;
  position: relative;
  transition: 0.5s;
  left: 0;
  ${(props) =>
    !props.$visible &&
    css`
      left: -120%;
    `}
`;

export const Empty = styled.div`
  pointer-events: none;
`;

export const SidebarWrapper = styled.div`
  position: relative;
  pointer-events: none;
  display: flex;
  justify-content: flex-end;
  /* grid-row: 2/4; */
  /* grid-column: 3/4; */
  * {
    pointer-events: auto;
  }
  display: flex;
  gap: 1rem;
  padding-right: 1rem;
  align-items: flex-end;
  flex-direction: column;
  grid-column: 3;
  grid-row: 2 / 5;
  margin-bottom: 1rem;
`;
export const SidebarSubwrapper = styled.div`
  background: #fff;
  height: 100%;
  position: relative;
  right: -120%;
  ${(props) =>
    props.$visible &&
    css`
      right: 0;
    `}
  border-left: var(--primary-border);
  border-radius: 20px;
  z-index: 4;
  pointer-events: none;
  * {
    pointer-events: auto;
  }
  transition: 0.5s all;
  width: 100%;
  ${(props) =>
    props.$isFullscreen &&
    css`
      border-radius: 20px 0 0 20px;
    `}
`;
